import React,{useEffect} from 'react'
import {NavLink,useNavigate,useLocation} from 'react-router-dom'
import { useSelector,useDispatch } from 'react-redux'
import {SIGNINOUT_USER} from "../redux/features/user/userSlice"
import {CLEAR_FILTER_DATA} from "../redux/features/user/filterSlice"
import {NavigationLink} from "../components/"
import exist from "../assests/exist.png"
import { getImgSrc } from '../helpers/getImgSrc'
import { CLEAR_USER_TOUR } from '../redux/features/user/userTourSlice'




const Sidebar = ({sidebar_options,tab,isOpenSidebar,setIsOpenSidebar,sidebar}) => {

 const user=useSelector((state)=>state?.user)
 const dispatch=useDispatch()
 const navigate=useNavigate()
 const location = useLocation();



 const handleLogout =()=>{
    if(user && user?.is_super_admin)
        {
            navigate('/super_admin/login')
            dispatch(SIGNINOUT_USER())
        }
        else{
            navigate('/client/login')
            dispatch(SIGNINOUT_USER())
            dispatch(CLEAR_FILTER_DATA())
            dispatch(CLEAR_USER_TOUR())

        }

 }
//  useEffect(()=>{

//  },[])


  
  return (
    <div ref={sidebar}  className={`sidebar ${isOpenSidebar &&'open'} ${!isOpenSidebar && tab==="user_profile"?"hide_sidebar":""} `}>
    <div className=" d-flex justify-content-between  flex-column">
        <div className="sidebar-header   w-100">
           <div className="d-flex align-items-center gap-2">
              <img  src={getImgSrc("logo-2","svg")} alt="" width={25} />
              <div className={` ${!isOpenSidebar &&tab==="user_profile"?"d-none":"d-md-block"}  logo_heading  d-flex justify-content-center flex-column `}>
                <p className="mb-0">University </p>
                <p className="mb-0">Intelligence</p>
              </div>
           </div>
           {isOpenSidebar && <i className='bi bi-x-lg  fs-2 p-2' onClick={()=>setIsOpenSidebar(false)} ></i>}

        </div>
        <div className="sidebar_body w-100 pt-2"
        >
                 {sidebar_options.map((option)=>{
                  let isActive=location.pathname.startsWith(option?.path)
                                      
                     return <NavigationLink option={option} tab={tab} key={option.label} isOpenSidebar={isOpenSidebar}  />
             })}
                  
        </div>
        <div className=" d-flex align-items-center ">
            <div className="sidebar-footer w-100 d-flex justify-content-between align-items-center">
                <div className={`relative  d-flex align-items-center gap-3 ${!isOpenSidebar && tab==="user_profile"?"d-none":"d-block"} `}>
            { user?.profile_image?
                <img src={user?.profile_image}
                className="img-fluid footer_profile_image  " alt="" />:
                <div style={{width:'3vw',height:'3vw',borderRadius:'50%'}} className='footer_profile_div d-flex justify-content-center align-items-center'>
                 <p className='mb-0'> {user?.first_name[0]?.toUpperCase()}  {user?.last_name[0]?.toUpperCase()}</p>
                </div>}
            
            
            
                
                
                    {/* <img className="img-fluid footer_profile_image d-none d-md-block "
                       src={user?.is_super_admin?super_admin:"https://images.unsplash.com/photo-1633332755192-727a05c4013d?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"}
                        alt="profile_image" /> */}
                    <div className=" footer_profile_text mt-3  ">
                        {user?.is_client && (
                            <>
                            <p className="mb-0">{user?.first_name} {user?.last_name}</p>
                           <NavLink to={user?.role_id<3?"settings/client_profile":"settings/user_profile"} className="mt-0 pt-0">
                            <p className=""> Edit Profile</p>
                          </NavLink>
                            </>
                        )}
                        {user?.is_super_admin && (
                            <>
                            <p className="mb-0">{user?.first_name} {user?.last_name}</p>
                           <NavLink to={"edit_profile"} className="mt-0 pt-0">
                            <p className=""> Edit Profile</p>
                          </NavLink>
                            </>
                        )}
                

                    </div>

                </div>
                <div>
                    <NavLink onClick={handleLogout}>
                       <img src={exist} style={{width:'36px',height:'36px'}}  />
                    </NavLink>


                </div>
            </div>

        </div>



    </div>

</div>

  )
}

export default Sidebar